import { useState } from "react";

import { useTimeout } from "usehooks-ts";

import { NodePill } from "src/base-components/NodePill";
import { Pill } from "src/base-components/Pill";
import { BeMappedNode } from "src/constants/NodeDataTypes";

type Props = {
  node: BeMappedNode | null;
  delay: number;
};

export const NodeMention = ({ node, delay }: Props) => {
  const [render, setRender] = useState(delay ? false : true);

  useTimeout(() => setRender(true), 1000 * delay);

  return (
    render && (
      <span className="mx-1 inline-flex">
        {node ? (
          <NodePill node={node} />
        ) : (
          <Pill size="sm" variant="gray" fullWidth>
            <Pill.Text>Node not found</Pill.Text>
          </Pill>
        )}
      </span>
    )
  );
};
